import { Component, input } from '@angular/core';

@Component({
	selector: 'heart-icon',
	templateUrl: './heart-icon.html',
	standalone: true
})
export class HeartIconComponent {
	color = input<string>('#9CA3AF');
	size = input<number>(12);
}
